export const parseQuery = (query) => {
  const conditions = query?.split(" ")?.filter(Boolean);
  const parsedConditions = conditions?.map((condition) => {
    const [key, operator, value] = condition?.split(/(==|!=|<=|>=|<|>)/);

    return { key, operator, value: value ? value?.trim() : null };
  });
  return parsedConditions;
};
